<template>
  <div>
    <div class="achievements">
      <div v-for="achievement in achievements" :key="achievement.achievement_id" class="achievement" @mouseover="showAchievementInfo = achievement.achievement_id" @mouseleave="showAchievementInfo = null">
        <img :src="'/' + achievement.icon" :height="getWidthHeight()">
        <div v-if="showAchievementInfo===achievement.achievement_id" class="alert alert-info">
          <div class="small text-left">
            <strong>{{ achievement.name }}</strong><br />
            <span v-if="achievement.description" class="br">{{ achievement.description }}</span>
            <a v-if="achievement.link" :href="achievement.link">Meer informatie</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showAchievementInfo: null
    };
  },
  props: {
    size: String,
    achievements: Array
  },
  methods: {
    getWidthHeight: function() {
      if (this.size === "small")
        return 40;
      else
        return 55;
    }
  }
};
</script>

<style scoped>
.achievements {
  display: flex;
  flex-wrap: wrap;
}

.achievements .achievement {
  padding-right: 5px;
}

.achievements .achievement .alert {
  position: absolute;
  width: 180px;
  z-index: 5;
}

.achievements .achievement .alert strong {
  font-weight: bold;
}

.achievements .achievement .alert a {
  display: block;
}
</style>
